import Component from "./MultiWindowTable";
export default Component;
